// extracted by mini-css-extract-plugin
export default {"gold":"styles_gold__kFech","gray":"styles_gray__h8i66","alert":"styles_alert__j+GnF","star":"styles_star__Ig3t8","disabled":"styles_disabled__uGHiE"};